export interface LogoProps {
    width?: any;
    height?: any;
    onClick?: any;
    textClassName?: string;
}

const Logo = ({width, height, onClick, textClassName}: LogoProps) => {
    return (
        <div onClick={onClick} className={'flex flex-row items-center'}>
            <img src={`/assets/images/logo.png`}
                 width={width} height={height} alt=""/>
            <span className={`${textClassName} font-semibold font-roboto`}>DataLookup</span>
        </div>
    );
}

export default Logo;
